import { ChangeEvent, FocusEvent } from 'react';
import { FieldRenderProps } from 'react-final-form';

const fieldProps = [
  'afterSubmit',
  'allowNull',
  'beforeSubmit',
  'data',
  'defaultValue',
  'format',
  'formatOnBlur',
  'initialValue',
  'isEqual',
  'multiple',
  'parse',
  'subscription',
  'validate',
  'validateFields',
  'name',
];
type OmittedProps = 'afterSubmit'|'allowNull'|'beforeSubmit'|'data'|'defaultValue'|'format'|'formatOnBlur'|'initialValue'|'isEqual'|'multiple'|'parse'|'subscription'|'validate'|'validateFields'|'name';

function filterProps<Q>(props: Q): Omit<Q, OmittedProps>  {
  return Object.fromEntries(
    Object.entries(props).filter(([key,]) => !fieldProps.includes(key))
  ) as Omit<Q, OmittedProps>;
}

interface Props {
  [key: string]: any,
}

function mergeInputProps<T extends FieldRenderProps<any>['input'], Q extends Props>(input: T, props: Q): T & Omit<Q, OmittedProps> {
  return {
    ...filterProps(props),
    ...input,
    checked: props.checked ?? input.checked,
    onChange(e: ChangeEvent<HTMLElement>, editor) {
      if (input.onChange) input.onChange(e);
      if (props.onChange) props.onChange(e, editor);
    },
    onBlur(e: FocusEvent<HTMLElement>, editor) {
      if (input.onBlur) input.onBlur(e);
      if (props.onBlur) props.onBlur(e, editor);
    },
    onFocus(e: FocusEvent<HTMLElement>, editor) {
      if (input.onFocus) input.onFocus(e);
      if (props.onFocus) props.onFocus(e, editor);
    },
  };
}

export default mergeInputProps;
